import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "with-side-panel" }
const _hoisted_2 = { class: "content-i" }
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { class: "element-wrapper" }
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = { class: "element-header" }
const _hoisted_7 = { class: "element-box" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-4 col-md-6" }
const _hoisted_10 = { class: "col-lg-4 col-md-6" }
const _hoisted_11 = { class: "col-lg-4 col-md-12" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "mt-5" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "row mt-3" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "form-buttons-w text-center mt-4" }

import clientService from '@/api/Client';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import SelectedDropdown from '@/components/SelectDropdown.vue';
import SelectVue from '@/components/SelectVue.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
// @ts-ignore
import {getOfficeDropdown} from '@/shared/dropdowns';
import {isValidEmail, requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import {IClient, IEnums, ILocation} from "@/interfaces/Client/IClient";
import TextEditor from "@/components/TextEditor.vue";
import BackButton from "@/components/button/BackButton.vue";
import SaveButton from "@/components/button/SaveButton.vue";
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const piniaEnumsState = piniaEnumsStore();
const getEnums = computed<IEnums>(() => piniaEnumsState.enums as unknown as IEnums);
const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyKey = companySettings.value?.companyKey;

const {t} = useI18n();
const billingTypeDropdown = ref<string[]>([])
const officeDropdown = ref([]);
const isSubmitting = ref(false);
const route = useRoute();
const clientId = route.params.id;

const formData = ref<IClient>({
  customerNumber: '',
  registrationOffice: '',
  name: '',
  forAttention: '',
  addressFirst: '',
  addressSecond: '',
  payerIk: '',
  billingType: '',
  city: '',
  zip: '',
  phone: '',
  email: '',
  pauschal: 0,
  debtor: '',
  officeIds: [],
  specialFeatures: '',
  specialFeaturesForCoach: '',
  unitsReduction: false
});

const rules = computed(() => {
  return {
    registrationOffice: requiredRule(t),
    name: requiredRule(t),
    addressFirst: requiredRule(t),
    city: requiredRule(t),
    zip: requiredRule(t),
    email: isValidEmail(t),
    officeIds: companyKey === 'BSG' ? requiredRule(t) : '',
  };
});

const v$ = useVuelidate<IClient>(rules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  // Set billingType to null if it's an empty string
  if (formData.value.billingType === '') {
    formData.value.billingType = null;
  }

  // Convert numeric fields from string to number
  formData.value.pauschal = Number(formData.value.pauschal); // or parseFloat if you prefer

  try {

    clientId ?
        await clientService.putClient(formData.value, +clientId) :
        await clientService.postClient(formData.value)

    await router.push({name: 'clientList'});
    isSubmitting.value = false;

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getClient() {
  try {
    const {data} = await clientService.getClient(+clientId);
    const officeIds = (data.data.locations as ILocation[] || [])
        .map((loc) => loc.id)
        .filter((id): id is number => id != null);

    formData.value = {...data.data, officeIds: officeIds};
    formData.value.debtor = data.data?.debtor || '';
    formData.value.billingType = formData.value.billingType ?? '';
  } catch (error) {
    await ErrorToast(error);
  }
}

async function nextClientNumber() {
  try {
    const {data} = await clientService.getClientNextNumber();
    formData.value.customerNumber = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getPrivateCoachingEnumBillingTypes() {
  billingTypeDropdown.value = getEnums?.value?.privateCoachingBillingTypes || [];
}

onMounted(async () => {
  CloseToast();

  await getOfficeDropdown(officeDropdown);
  await getPrivateCoachingEnumBillingTypes();

  if (clientId) {
    await getClient();
  } else {
    await nextClientNumber();
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BackButton, {
            label: _ctx.$t('general.button.back'),
            to: { name: 'clientList' },
            marginBottom: "5"
          }, null, 8, ["label"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.$t('client.title')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(submitForm, ["prevent"]),
              novalidate: ""
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(BaseInput, {
                    modelValue: formData.value.customerNumber,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.customerNumber) = $event)),
                    label: "Kundennummer",
                    readonly: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(BaseInput, {
                    modelValue: formData.value.registrationOffice,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.registrationOffice) = $event)),
                    label: "Abrechnungsstelle",
                    required: true,
                    validation: _unref(v$).registrationOffice,
                    messages: _unref(v$).registrationOffice.required.$message
                  }, null, 8, ["modelValue", "validation", "messages"]),
                  _createVNode(BaseInput, {
                    modelValue: formData.value.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.name) = $event)),
                    label: "Kostenträger",
                    required: true,
                    disabled: formData.value.hubspotId,
                    validation: _unref(v$).name,
                    messages: _unref(v$).name.required.$message
                  }, null, 8, ["modelValue", "disabled", "validation", "messages"]),
                  _createVNode(BaseInput, {
                    modelValue: formData.value.forAttention,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.forAttention) = $event)),
                    label: "Z Hd."
                  }, null, 8, ["modelValue"]),
                  _createVNode(BaseInput, {
                    modelValue: formData.value.payerIk,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.payerIk) = $event)),
                    label: "Kostenträger IK"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(BaseInput, {
                    modelValue: formData.value.addressFirst,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.addressFirst) = $event)),
                    label: "Adresszeile 1",
                    required: true,
                    disabled: formData.value.hubspotId,
                    validation: _unref(v$).addressFirst,
                    messages: _unref(v$).addressFirst.required.$message
                  }, null, 8, ["modelValue", "disabled", "validation", "messages"]),
                  _createVNode(BaseInput, {
                    modelValue: formData.value.addressSecond,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.addressSecond) = $event)),
                    label: "Adresszeile 2"
                  }, null, 8, ["modelValue"]),
                  _createVNode(BaseInput, {
                    modelValue: formData.value.zip,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.zip) = $event)),
                    label: "PLZ",
                    required: true,
                    disabled: formData.value.hubspotId,
                    validation: _unref(v$).zip,
                    messages: _unref(v$).zip.required.$message
                  }, null, 8, ["modelValue", "disabled", "validation", "messages"]),
                  _createVNode(BaseInput, {
                    modelValue: formData.value.city,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.city) = $event)),
                    label: "Ort",
                    required: true,
                    disabled: formData.value.hubspotId,
                    validation: _unref(v$).city,
                    messages: _unref(v$).city.required.$message
                  }, null, 8, ["modelValue", "disabled", "validation", "messages"]),
                  _createVNode(BaseInput, {
                    modelValue: formData.value.phone,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.phone) = $event)),
                    disabled: formData.value.hubspotId,
                    label: "Telefonnummer"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(BaseInput, {
                    modelValue: formData.value.email,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.email) = $event)),
                    type: "email",
                    label: "Email",
                    validation: _unref(v$).email,
                    disabled: formData.value.hubspotId,
                    messages: _unref(v$).email.isValidEmail.$message
                  }, null, 8, ["modelValue", "validation", "disabled", "messages"]),
                  _createVNode(BaseInput, {
                    modelValue: formData.value.debtor,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.debtor) = $event)),
                    type: "number",
                    label: "Debitor"
                  }, null, 8, ["modelValue"]),
                  _createVNode(BaseInput, {
                    modelValue: formData.value.pauschal,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.pauschal) = $event)),
                    type: "number",
                    label: "Pauschalabrechnung (%)"
                  }, null, 8, ["modelValue"]),
                  (billingTypeDropdown.value && billingTypeDropdown.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(SelectedDropdown, {
                          modelValue: formData.value.billingType,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.billingType) = $event)),
                          options: billingTypeDropdown.value,
                          label: "Art der Abrechnung",
                          placeholder: "Wählen Sie die Art der Abrechnung aus"
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(BaseCheckbox, {
                      modelValue: formData.value.unitsReduction,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.unitsReduction) = $event)),
                      label: "Reduzierung der UE bei UN",
                      labelPosition: "right"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              (_unref(companyKey) === 'BSG')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      (officeDropdown.value && officeDropdown.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(SelectVue, {
                              modelValue: formData.value.officeIds,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.officeIds) = $event)),
                              options: officeDropdown.value,
                              "is-clear": true,
                              "is-multi": true,
                              required: true,
                              label: "Standort",
                              validation: _unref(v$).officeIds,
                              messages: _unref(v$).officeIds.required.$message
                            }, null, 8, ["modelValue", "options", "validation", "messages"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(TextEditor, {
                    modelValue: formData.value.specialFeatures,
                    "onUpdate:modelValue": [
                      _cache[16] || (_cache[16] = ($event: any) => ((formData.value.specialFeatures) = $event)),
                      _cache[17] || (_cache[17] = ($event: any) => (formData.value.specialFeatures = $event))
                    ],
                    inputStyle: { height: '150px' },
                    label: "Besonderheiten intern"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(TextEditor, {
                    modelValue: formData.value.specialFeaturesForCoach,
                    "onUpdate:modelValue": [
                      _cache[18] || (_cache[18] = ($event: any) => ((formData.value.specialFeaturesForCoach) = $event)),
                      _cache[19] || (_cache[19] = ($event: any) => (formData.value.specialFeaturesForCoach = $event))
                    ],
                    inputStyle: { height: '150px' },
                    label: "Besonderheiten für Coaches"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(SaveButton, {
                  label: _ctx.$t('general.button.save'),
                  loading: isSubmitting.value
                }, null, 8, ["label", "loading"])
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}
}

})